import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=44114c0b&scoped=true"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"
import style0 from "./blank.vue?vue&type=style&index=0&id=44114c0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44114c0b",
  null
  
)

export default component.exports